import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, unref as _unref, toDisplayString as _toDisplayString, withCtx as _withCtx, normalizeClass as _normalizeClass, Transition as _Transition, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("span", { class: "sr-only" }, "Open user menu", -1)
const _hoisted_2 = { class: "flex items-center justify-end space-x-4" }
const _hoisted_3 = { class: "hidden md:inline text-16m font-medium text-wrh-gray-600" }

import { ref, computed } from 'vue';
// import { getAuth, signOut } from 'firebase/auth'
import { useRouter } from 'vue-router';
import {
  Menu, MenuItems, MenuItem, MenuButton,
} from '@headlessui/vue';
import UserAvatar from './UserAvatar.vue';


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const auth = {
  currentUser: {
    authenticated: true,
    data: [],
    displayName: 'Buyer Name',
  },
};
const displayName = computed(() => auth.currentUser?.displayName);
const router = useRouter();

const leave = async () => {
  // await signOut(getAuth())
  router.push({ path: '/login' });
};

return (_ctx: any,_cache: any) => {
  return (auth.currentUser)
    ? (_openBlock(), _createBlock(_unref(Menu), {
        key: 0,
        as: "div",
        class: "mr-3 relative z-1"
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", null, [
            _createVNode(_unref(MenuButton), { class: "max-w-xs flex items-center text-sm rounded-full md:pr-3 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500" }, {
              default: _withCtx(() => [
                _hoisted_1,
                _createElementVNode("div", _hoisted_2, [
                  _createVNode(UserAvatar, {
                    user: auth.currentUser,
                    class: "h-8 w-8 md:h-10 md:w-10"
                  }, null, 8, ["user"]),
                  _createElementVNode("span", _hoisted_3, _toDisplayString(_unref(displayName)), 1)
                ])
              ]),
              _: 1
            })
          ]),
          _createVNode(_Transition, {
            "enter-active-class": "transition ease-out duration-100",
            "enter-from-class": "transform opacity-0 scale-95",
            "enter-to-class": "transform opacity-100 scale-100",
            "leave-active-class": "transition ease-in duration-75",
            "leave-from-class": "transform opacity-100 scale-100",
            "leave-to-class": "transform opacity-0 scale-95"
          }, {
            default: _withCtx(() => [
              _createVNode(_unref(MenuItems), { class: "origin-top-right absolute right-0 mt-2 w-48 rounded-md shadow-lg bg-white ring-1 ring-black ring-opacity-5 py-1 focus:outline-none" }, {
                default: _withCtx(() => [
                  _createVNode(_unref(MenuItem), null, {
                    default: _withCtx(({ active }) => [
                      _createElementVNode("span", {
                        class: _normalizeClass([
              active ? 'bg-gray-100' : '',
              'w-full block py-2 px-4 text-sm text-gray-700',
            ])
                      }, " Profile ", 2)
                    ]),
                    _: 1
                  }),
                  _createVNode(_unref(MenuItem), null, {
                    default: _withCtx(({ active }) => [
                      _createElementVNode("span", {
                        class: _normalizeClass([
              active ? 'bg-gray-100' : '',
              'w-full block py-2 px-4 text-sm text-gray-700',
            ])
                      }, " Settings ", 2)
                    ]),
                    _: 1
                  }),
                  _createVNode(_unref(MenuItem), { onClick: leave }, {
                    default: _withCtx(({ active }) => [
                      _createElementVNode("span", {
                        class: _normalizeClass([
              active ? 'bg-gray-100' : '',
              'w-full block py-2 px-4 text-sm text-gray-700',
            ])
                      }, " Sign out ", 2)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }))
    : _createCommentVNode("", true)
}
}

})